var PropertyRecordsModel = function (options) {
  this.data = options.data;
  this.getData = function () {
    return this.data;
  };
};

export { PropertyRecordsModel };



// WEBPACK FOOTER //
// ./property_records/models/page.js